import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Commissioning aid: which release is this, really. Quiet by default, details on demand. */
export const AboutRelease = () => {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/build-info`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => alive && setInfo(d))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!info) return null;

  return (
    <div className="pt-2" data-testid="about-release">
      <button
        type="button"
        data-testid="about-release-toggle"
        onClick={() => setOpen((v) => !v)}
        className="text-[12px] text-archival-muted hover:text-archival-secondary transition-colors"
      >
        {info.app} · <span data-testid="about-release-id">{info.release_id}</span>
      </button>
      {open && (
        <dl className="mt-2 grid grid-cols-[auto,1fr] gap-x-4 gap-y-1 text-[12px] text-archival-muted">
          <dt>Release</dt>
          <dd className="font-mono text-archival-secondary">{info.release_id}</dd>
          <dt>Source revision</dt>
          <dd className="font-mono break-all" data-testid="about-source-revision">
            {info.source_revision}
          </dd>
          <dt>Environment</dt>
          <dd data-testid="about-environment">{info.environment}</dd>
          <dt>Frontend build</dt>
          <dd className="font-mono">{info.frontend_build}</dd>
          <dt>Backend build</dt>
          <dd className="font-mono">{info.backend_build}</dd>
          <dt>Config</dt>
          <dd className="font-mono">{info.config_fingerprint}</dd>
        </dl>
      )}
    </div>
  );
};
